module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/weibo.7237d25b.png";